import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { CarouselProvider } from 'src/common/providers/CarouselProvider';
import boatCategories from 'src/common/boatCategories';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Carousel from 'src/common/components/dockyard/Carousel';
import CarouselButtons from 'src/common/components/dockyard/CarouselButtons';
import Typography from 'src/common/components/Typography';
import BoatTypeCard from 'src/common/components/BoatTypeCard';
import styles from './Hero.module.scss';

/** Category ids */
const boatTypeCarouselCategories = [
  21, 18, 19, 4, 7, 20, 17, 42, 13, 69, 36, 37, 35, 65, 60, 83, 64,
];

const Hero: FC = () => {
  const [t] = useTranslation('categories');
  return (
    <div className={styles.layout}>
      <PitchPageLayout
        backgroundColor="ivory"
        outerChildren={(
          <div className={styles.categoryCarousel}>
            <CarouselProvider>
              <Carousel>
                {boatTypeCarouselCategories.map((id) => (
                  <BoatTypeCard
                    key={id}
                    urlSegment={boatCategories[id]}
                    hasCta={false}
                    hasDescription={false}
                  />
                ))}
              </Carousel>
              <div className={styles.buttonsDesktop}>
                <CarouselButtons
                  spacing="together"
                  variant="primary-dark"
                />
              </div>
            </CarouselProvider>
          </div>
        )}
      >
        <div className={styles.root}>
          <div className={styles.title}>
            <Typography
              type="h1"
              size="display-4"
              sizeFromBreakpointM="display-3"
            >
              {t('categories--experiences-title')}
            </Typography>
          </div>
        </div>
      </PitchPageLayout>
    </div>
  );
};

export default Hero;
